import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
export function IncludedSection() {
  const fadeIn = useFadeIn();
  const benefits = [{
    emoji: '💬',
    text: 'Charlar más y conectar de verdad'
  }, {
    emoji: '😄',
    text: 'Crear recuerdos inolvidables'
  }, {
    emoji: '💖',
    text: 'Fortalecer la confianza'
  }, {
    emoji: '⏰',
    text: 'Aprovechar el tiempo juntos'
  }, {
    emoji: '🌈',
    text: 'Recuperar la alegría'
  }, {
    emoji: '✨',
    text: 'Salir de la rutina'
  }, {
    emoji: '🧠',
    text: 'Entender más a tus hijos'
  }, {
    emoji: '🎯',
    text: 'Ahorrar tiempo planificando'
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-107">
      <div className="max-w-3xl mx-auto" data-id="element-108">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-109">
          <div className="text-center mb-10 md:mb-12" data-id="element-110">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-111">
              💙 ¿Qué vas a lograr?
            </h2>
            <div className="w-24 h-2 bg-blue-600 mx-auto rounded-full" data-id="element-112"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-113">
            {benefits.map((b, i) => <div key={i} className="bg-blue-50 p-5 rounded-xl flex gap-4 items-center border border-blue-100" data-id="element-114">
                <span className="text-3xl flex-shrink-0" data-id="element-115">{b.emoji}</span>
                <p className="text-base md:text-lg text-gray-800 font-bold" data-id="element-116">
                  {b.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}